import { useEffect } from "react";
import { MessageCenterWorkspace } from "./MessageCenterWorkspace";

interface MessageCenterPanelProps {
  open: boolean;
  unreadCount: number;
  onClose: () => void;
}

export function MessageCenterPanel({
  open,
  unreadCount,
  onClose,
}: MessageCenterPanelProps) {
  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose, open]);

  return (
    <div
      className={`message-panel-layer${open ? " open" : ""}`}
      aria-hidden={!open}
      inert={!open}
    >
      <button
        type="button"
        className="message-panel-backdrop"
        aria-label="关闭消息中心"
        tabIndex={open ? 0 : -1}
        onClick={onClose}
      />
      <aside className="message-slide-panel" role="dialog" aria-modal="true">
        <header className="message-slide-header">
          <span className="message-drawer-title">
            消息中心 <small>{unreadCount} 条未读</small>
          </span>
          <button
            type="button"
            className="message-panel-close"
            aria-label="关闭消息中心"
            tabIndex={open ? 0 : -1}
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <div className="message-slide-body">
          <MessageCenterWorkspace active={open} compact onNavigate={onClose} />
        </div>
      </aside>
    </div>
  );
}
